
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.498 5.022a2.099 2.099 0 100-4.2 2.099 2.099 0 100 4.2zm1.44.6h-.155c-.39.187-.823.3-1.285.3a2.96 2.96 0 01-1.284-.3h-.156a2.16 2.16 0 00-2.16 2.16v.54a.9.9 0 00.9.9h5.4a.9.9 0 00.9-.9v-.54a2.16 2.16 0 00-2.16-2.16zm3.96-.6a1.8 1.8 0 100-3.601 1.8 1.8 0 000 3.6zm.9.6h-.07c-.261.09-.537.15-.83.15-.292 0-.568-.06-.828-.15h-.072c-.382 0-.735.11-1.044.289.458.493.744 1.147.744 1.87v.72c0 .042-.009.081-.01.12h3.31a.9.9 0 00.9-.9c0-1.16-.939-2.1-2.1-2.1z","fill":"#fff","fill-opacity":".65"}})])
          )
        }
      }
    